export default "__VITE_ASSET__DhWb0Ik5__"